import React from 'react';
import { Container, makeStyles } from '@material-ui/core';

import { CreateMeetingContextProvider } from '../../../services/create-meeting/create-meeting.context';
import { DateTimeContextProvider } from '../../../services/dataTime/dateTime.context';

import { CreateMeeting } from './create-meeting';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexGrow: 1,
      margin: '0 auto',
      padding: '0',
    },
  };
});

export const CreateMeetingContainer = (props) => {
  const classes = useStyles();

  const {
    location: { state = '' },
  } = props;

  return (
    <Container className={classes.root}>
      <DateTimeContextProvider>
        <CreateMeetingContextProvider>
          <CreateMeeting state={state} />
        </CreateMeetingContextProvider>
      </DateTimeContextProvider>
    </Container>
  );
};
